{
  "actions": "Действия",
  "add_event_to_google_calendar": "Добавить событие в Google Календарь",
  "add_guests": "Добавить участников",
  "calendar": "Календарь",
  "calendar_events": "События календаря",
  "calendar_settings": "Настройки календаря",
  "celebrations": "Празднования",
  "conference": "Конференция",
  "congratulate_colleague": "Поздравьте коллегу с днем рождения!",
  "create_meeting": "Создать встречу",
  "create_meeting_for_department": "Для департамента {name}",
  "create_meeting_for_team": "Для команды {name}",
  "employee_no_email": "У {name} не указан email в профиле, его нельзя добавить во встречу",
  "employee_no_email_open_profile": "Открыть профиль",
  "enable_calendar": "Включить календарь компании",
  "enable_calendar_description": "Включает общий календарь для отображения важных дат сотрудников, таких как отсутствия, дни рождения, годовщины и другие события, способствуя координации и осведомленности команды",
  "event_all_day": "Весь день",
  "event_create_title": "Создать событие",
  "event_delete": "Удалить событие",
  "event_delete_description": "Это событие будет удалено из всех календарей для всех участников",
  "event_edit_title": "Изменить событие",
  "event_end_time": "Время завершения",
  "event_start_time": "Время начала",
  "event_visibility": "Видимость",
  "event_visibility_private": "Приватное (видно только вам и гостям)",
  "event_visibility_public": "Публичное (видно всем)",
  "events": "События",
  "external_contact": "Внешний контакт",
  "get_ready_to_celebrate_colleague_birthday": "Приготовьтесь поздравить коллегу с предстоящим днем рождения!",
  "get_ready_to_celebrate_your_birthday": "Приготовьтесь отпраздновать свой особенный день!",
  "going_question": "Пойдете?",
  "google_meet": "Google Meet",
  "guest_group_invite": "Пригласить",
  "guest_group_invite_link": "группу участников",
  "guests": "Участники",
  "happy_birthday": "С днем рождения вас!",
  "invite": "Пригласить",
  "join": "Присоединиться",
  "kontur_talk": "Контур Толк",
  "link_will_be_created_after_event_creation": "Ссылка будет доступна после создания события",
  "no_conference": "Без конференции",
  "no_title": "Без названия",
  "notification_settings_calendar_events_caption": "Когда создаётся или изменяется событие с вашим участием",
  "organizer": "Организатор",
  "remove_guest": "Удалить участника",
  "response_status_accepted": "Принято",
  "response_status_needs_action": "Ожидается ответ",
  "response_status_needs_declined": "Отклонено",
  "response_status_needs_tentative": "Возможно",
  "settings_calendar_description": "Управляйте корпоративными событиями и отсутствиями",
  "show_anniversaries": "Показ годовщин",
  "show_anniversaries_description": "Отмечает годовщины работы, облегчая признание ключевых событий для сотрудников",
  "show_birthdays": "Показ дней рождений",
  "show_birthdays_description": "Отображает дни рождения сотрудников, способствуя командной поддержке и празднованию личных событий",
  "show_employee_leaves": "Показ отсутствий сотрудников",
  "show_employee_leaves_description": "При включении в календаре отображаются периоды отсутствия сотрудников (например, отсутствие или больничный)",
  "show_last_day_of_employees": "Показ последнего рабочего дня сотрудника",
  "show_last_day_of_employees_description": "Отображает последний рабочий день увольняющихся сотрудников, что помогает в планировании переходного периода",
  "show_starting_dates_of_new_hires": "Показ даты начала работы новых сотрудников",
  "show_starting_dates_of_new_hires_description": "Отмечает даты начала работы, что помогает отслеживать процесс адаптации новых сотрудников.",
  "upcoming": "Предстоящее",
  "view_calendar": "Просмотреть календарь",
  "zoom": "Zoom",
  "~": "~",
  "availability_title": "Занятость участников",
  "availability_edit_note": "Редактируемая встреча тоже может отображаться как занятое время.",
  "availability_groups_title": "Занятость участников из групп не учтена",
  "availability_groups_note": "Проверяются только сотрудники, добавленные по одному. Участники из групп не учтены.",
  "availability_error": "Не удалось проверить календари. Встречу можно сохранить.",
  "availability_retry": "Повторить",
  "availability_select_for": "Выбрать время встречи на шкале {name}",
  "availability_busy_time": "Занят: {start}–{end}",
  "availability_suggestions": "Свободное время · 09:00–20:00",
  "availability_no_slots": "На этот день с 09:00 до 20:00 не осталось времени для встречи такой длительности. Выберите другой день или измените длительность в окне встречи.",
  "availability_day": "День",
  "availability_add_employees": "Добавьте сотрудников в список гостей, чтобы увидеть их занятость.",
  "availability_open": "Подобрать время",
  "availability_guest_conflict": "Время встречи пересекается с другим событием этого участника.",
  "availability_close": "Закрыть подбор времени",
  "availability_meeting_timezone": "Часовой пояс встречи: {timezone} ({offset})."
}
